import useLocation from '@lmig/dotcom-aspect-hooks/useLocation';
import Logger from '@lmig/dotcom-utilities-helpers/logger';

const logger = new Logger('client:Utility:GetUserLocation');

const GetUserLocation = ({ html = false, useZip = true }) => {
  const { location } = useLocation(html, useZip);

  logger.debug(`GetUserLocation location (html: ${html}, useZip: ${useZip}): ${JSON.stringify(location)}`);

  return null;
};

export default GetUserLocation;
